import axios from 'axios';

import { authHeader } from '../_helpers';
import { urlAPI } from './index';

// ruta API de la entidad
let API = 'api/desarmadero/';

// Exporta metodos
export const desarmaderoService = {
    getAll,
    getAllAsync,
    getCompactAsync,
    getAllTVehiculoTBaja,
    getxcliente,
    getById,
    putObject,
    postObject,
    deleteObject
};

// Lee todos los elementos
function getAll() {
    return axios
        .get(urlAPI + API, authHeader())
        .then(registro => {
            return registro.data;
        });
}

async function getAllAsync() {
    var ret = axios.get(urlAPI + API, authHeader());
    return ret;
}

async function getCompactAsync() {
    var ret = axios.get(urlAPI + API , authHeader())
    return ret;
}

// Lee todos los elementos TVehiculoTBaja
function getAllTVehiculoTBaja() {
    return axios.get(urlAPI + API + "TVehiculoTBaja", authHeader()).then(registro => {
        return registro.data;
    });
}

// Lee solo los elementos relacionados con el id de la entidad padre marca
function getxcliente(id) {
    return axios
        .get(urlAPI + API + 'cliente/' + id, authHeader())
        .then(registro => {
            return registro.data;
        });
}

// Lee un solo elemento de la entidad
function getById(id) {
    return axios.get(urlAPI + API + id, authHeader()).then(registro => {
        return registro.data;
    });
}

// Post de la entidad
function postObject(obj) {
    // Copiar todas las propiedades menos id
    var modelo = {
        nombre: obj.nombre,
        //        yyyyId: obj.yyyy.id,
        direccion: obj.direccion,
        localidadId: obj.localidad.id,
        provinciaId: obj.provincia.id,
        zonainfluenciaId: obj.zonainfluencia.id,
        cuit: obj.cuit,
        codRUDAC: obj.codRUDAC,
        nombreRUDAC: obj.nombreRUDAC,
        VencimientoRUDAC: obj.vencimientoRUDAC,
        Telefono: obj.telefono,
        email: obj.email,
        Contacto: obj.contacto,
        //clienteDesarmadero: obj.clienteDesarmadero,
        cliDes: obj.cliDes,
        desTVhTBjDTO: obj.desTVhTBjDTO,
        borrado: obj.borrado
    };
    return axios.post(urlAPI + API, modelo, authHeader()).then(registro => {
        return registro.data;
    });
}

// put de la entidad
function putObject(obj) {
    // Copiar todas las propiedades
    var modelo = {
        id: obj.id,
        nombre: obj.nombre,
        //        yyyyId: obj.yyyy.id,
        direccion: obj.direccion,
        localidadId: obj.localidad.id,
        provinciaId: obj.provincia.id,
        zonainfluenciaId: obj.zonainfluencia.id,
        cuit: obj.cuit,
        codRUDAC: obj.codRUDAC,
        NombreRUDAC: obj.nombreRUDAC,
        VencimientoRUDAC: obj.vencimientoRUDAC,
        Telefono: obj.telefono,
        email: obj.email,
        Contacto: obj.contacto,
        //clienteDesarmadero: obj.clienteDesarmadero,
        cliDes: obj.cliDes,
        desTVhTBjDTO: obj.desTVhTBjDTO,
        borrado: obj.borrado
    };

    return axios
        .put(urlAPI + API + modelo.id, modelo, authHeader())
        .then(registro => {
            return registro.data;
        });
}

// delete de la entidad
function deleteObject(obj) {
    return axios.delete(urlAPI + API + obj, authHeader()).then(registro => {
        return registro.data;
    });
}
